import type React from "react";

import CookiesConsentModal from "./CookieConsetModal";
import { CookieConsentProvider } from "./CookiesConsentContext";

type CookieConsetWrapperProps = {
  children: React.ReactNode;
};

const CookieConsetWrapper = ({ children }: CookieConsetWrapperProps) => {
  // Skip cookie consent modal in tests (unit tests or E2E tests)
  // but still provide the context so components using useCookieConsentContext don't crash
  const shouldHideModal =
    import.meta.env.MODE === "test" ||
    import.meta.env.VITE_DISABLE_COOKIE_BANNER === "true";

  return (
    <CookieConsentProvider>
      {!shouldHideModal && <CookiesConsentModal />}
      {children}
    </CookieConsentProvider>
  );
};

export default CookieConsetWrapper;
